import { HTTP } from '../services'
import buildQuery from '@/helpers/url'

export default new (class CustomVenueService {
	getAll (country) {
		return HTTP.get('/v1/venues/custom/all?country=' + country)
	}

	getAllCustomVenues (country) {
		return HTTP.get('/v1/venues/custom/all', { params: { country } })
	}

	createCustomVenue(data) {
		return HTTP.post(`/v1/venues/custom`, data);
	}

	updateCustomVenue(customVenueId, data) {
		return HTTP.put(`/v1/venues/custom/${customVenueId}`, data);
	}

	deleteCustomVenue(customVenueId) {
		return HTTP.delete(`/v1/venues/custom/${customVenueId}`);
	}

	createCustomBooking(customVenueId, leadEventId, data) {
		return HTTP.post(
			'/v1/sales/lead-event/' +
        	leadEventId +
        	'/custom-venue-sale/' + 
			customVenueId,
			data
		)
	}

	createCustomSiteVisit(leadEventId, data) {
		return HTTP.post(
			'/v1/lead-event/' +
        	leadEventId +
        	'/custom-inspection',
			data
		)
	}
})()
